import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { Injectable } from '@angular/core';
import { Http, Response, Headers } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import {  } from '@angular/animations';

import { environment } from '../environment';
import { Module } from '../models/module';

@Component({
  selector: 'app-corps',
  templateUrl: './info.corporations.component.html'
})
export class CorporationsComponent implements OnInit {

	title: string;
	header: any;
  headerHeight: any;
	headerAlign: any;
	subtitle: string;

  constructor(private http      : Http,
              private sanitizer : DomSanitizer ) { }

  ngOnInit() {
  	this.title = 'CORPORATIONS';
    this.header = this.sanitizer.bypassSecurityTrustStyle( 'url( "/assets/img/art/tattoo-large.jpg") no-repeat' );
  	this.subtitle = 'Business is (sometimes) booming in Identity.';
    this.headerHeight = '545px';
    this.headerAlign = 'left';
  }

}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/info/info.corporations.component.ts